import { mergeStyles, PrimaryButton, Stack, useTheme } from '@fluentui/react';
import React, { useState } from 'react';
import { MobiscrollDatepicker } from '../Datepicker/MobiscrollDatepicker';
import { BaseComponentProps, Input } from '../types';
import { contextualFormStyles } from './ContextualFormStyles';
import Validator from 'validator';

export const ContextualForm = (props: BaseComponentProps): JSX.Element => {
  const { inputs, onSubmit } = props;
  const [inputValues, setInputValues] = useState<Array<Input>>(inputs);
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const theme = useTheme();
  const styles = contextualFormStyles(theme);

  const defaultOnChange = (key: string, value: string) => {
    for (let i = 0; i < inputValues.length; i++) {
      if (inputValues[i].key === key) {
        inputValues[i].value = value;
      }
    }

    // Validate Input values
    let validInputs = true;
    inputValues.forEach((input) => {
      if (!input.value) {
        validInputs = false;
      }
      if (input.validator) {
        switch (input.validator) {
        case 'email':
          validInputs = validInputs && Validator.isEmail(input.value);
          break;
        case 'zipcode':
          validInputs = validInputs && Validator.isPostalCode(input.value, 'US');
          break;
        case 'phone':
          validInputs = validInputs && Validator.isMobilePhone(input.value, 'en-US');
          break;
        default:
          break;
        }
      }
    });

    setSubmitDisabled(!validInputs);
    setInputValues(inputValues);
  };

  const handleSubmit = () => {
    console.log(inputValues);
    onSubmit && onSubmit(inputValues);
  };

  return (
    <Stack style={{ width: '85%' }}>
      <Stack styles={{ root: styles.containerRoot }}>
        <ul className={mergeStyles(styles.ul)}>
          {inputs.map((input) => {
            return (
              <li key={input.id}>
                <Stack horizontal>
                  <Stack style={{ width: '100%' }}>
                    {input.type === 'date' ? (
                      <MobiscrollDatepicker
                        defaultValue={input.value ? new Date(input.value) : undefined}
                        placeholder={input.name}
                        onChange={(value) => {
                          defaultOnChange(input.key, value.toLocaleDateString());
                        }}
                      />
                    ) : (
                      <input
                        className={mergeStyles(styles.inputField)}
                        type={input.type}
                        name={input.name}
                        defaultValue={input.value}
                        placeholder={input.name}
                        onChange={(value) => {
                          defaultOnChange(input.key, value.target.value);
                        }}
                      />
                    )}
                  </Stack>
                </Stack>
              </li>
            );
          })}
        </ul>
      </Stack>
      <Stack>
        <PrimaryButton
          disabled={submitDisabled}
          className={mergeStyles(styles.button)}
          styles={{
            rootDisabled: {
              backgroundColor: '#fff',
              color: '#999',
            },
          }}
          text="SUBMIT"
          onClick={() => handleSubmit()}
        />
      </Stack>
    </Stack>
  );
};
